export default __webpack_public_path__ + "static/media/black_brawn.6c76620d.png";